import Image from '../../../components/AppImage';
import { Tool } from '../types';

const ToolsSection = () => {
  const tools: Tool[] = [
    {
      id: "1",
      name: "n8n",
      logo: "https://n8n.io/brandguidelines/logo-dark.svg", 
      alt: "n8n workflow automation logo",
      category: "Workflow"
    },
    {
      id: "2",
      name: "Make.com",
      logo: "https://images.ctfassets.net/un655fb9wln6/1k5wBPhbu5kXiaYlFWgEJE/b590772959bd510e64cf230ef37bba3e/Make-Logo-RGB.svg",
      alt: "Make.com automation logo",
      category: "Workflow"
    },
    {
      id: "3",
      name: "OpenAI",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/4d/OpenAI_Logo.svg",
      alt: "OpenAI GPT-4 logo",
      category: "AI Intelligence"
    },
    {
      id: "4",
      name: "WhatsApp API",
      logo: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
      alt: "WhatsApp Business API logo",
      category: "Communication"
    },
    {
      id: "5",
      name: "HubSpot",
      logo: "data:image/svg+xml;base64,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",
      alt: "HubSpot CRM logo",
      category: "CRM"
    },
    {
      id: "6",
      name: "Shopify",
      logo: "https://upload.wikimedia.org/wikipedia/commons/0/0e/Shopify_logo_2018.svg",
      alt: "Shopify eCommerce logo",
      category: "E-commerce"
    },
    {
      id: "7",
      name: "Slack",
      logo: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Slack_icon_2019.svg",
      alt: "Slack integration logo",
      category: "Communication"
    },
    {
      id: "8",
      name: "Stripe",
      logo: "https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg",
      alt: "Stripe payments logo",
      category: "Finance"
    }
  ];

  return (
    <section className="bg-surface py-20 border-y border-border/50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-2xl lg:text-3xl font-bold text-text-primary">
            We Speak Your Tech Stack's Language
          </h2>
          <p className="text-text-secondary max-w-2xl mx-auto text-lg">
            We don't ask you to change your tools. We make them talk to each other.
            <span className="block mt-2 text-sm text-text-secondary/80">
              (Integrations available for 500+ apps)
            </span>
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-8 items-center">
          {tools.map((tool) => (
            <div
              key={tool.id}
              className="group flex flex-col items-center justify-center p-4 transition-all duration-300"
            >
              {/* Logo Container with Grayscale Effect */}
              <div className="relative w-12 h-12 lg:w-14 lg:h-14 mb-4 transition-all duration-300 filter grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110">
                <Image
                  src={tool.logo}
                  alt={tool.alt}
                  className="w-full h-full object-contain"
                />
              </div>
              
              {/* Tool Name (Hidden by default, shown on hover for cleaner look) */}
              <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-center">
                <p className="text-xs font-semibold text-text-primary">{tool.name}</p>
                <span className="text-[10px] text-primary bg-primary/10 px-2 py-0.5 rounded-full mt-1 inline-block">
                  {tool.category}
                </span>
              </div>
            </div>
          ))}
        </div>
        
        {/* Trust Line */}
        <div className="mt-12 text-center">
            <p className="text-sm text-text-secondary">
                Don't see your tool? <span className="text-primary font-medium cursor-pointer hover:underline">We build custom API connectors.</span>
            </p>
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;